import type { HeadlineModuleLevel as Level } from '@hypercodestudio/basler-components';

export function mapHeadlineLevel(
  level: 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6' | 'display-01'
) {
  if (level === 'display-01') {
    return 2;
  }

  return parseInt(level.replace('H', '')) as Level;
}
